"use client";
import Link from "next/link";
import { ArrowRight, Quote } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { lifeAt as data } from "@/lib/data/careers";

const accents = ["var(--color-amber)", "var(--color-emerald)", "var(--color-cyan)", "var(--color-purple)"];

export function LifeAt() {
  return (
    <Section id="life-at" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-amber)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          {data.quotes.map((q, i) => {
            const accent = accents[i % accents.length]!;
            return (
              <Reveal key={q.title} delay={i * 100}>
                <div className="relative h-full rounded-3xl glass p-7 overflow-hidden" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
                  <Quote className="h-6 w-6 mb-3 opacity-30" style={{ color: accent }} />
                  <div className="eyebrow-tiny font-bold" style={{ color: accent }}>{q.title}</div>
                  <p className="mt-3 text-body-sm text-[rgb(var(--fg-muted))] leading-relaxed italic">&ldquo;{q.body}&rdquo;</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
